import { __decorate } from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
import { postHeaders } from "@/api/api-require";
import axios from "axios";
import i18n from "@/config/i18n";
import { State } from "vuex-class";
import { piOhParseParam } from "@/utils/object.helper";
import { piThThisTimes } from "@/utils/time.helper";
let PiExport = class PiExport extends Vue {
    constructor() {
        super(...arguments);
        this.size = "";
        this.progress = "";
        this.loading = false;
    }
    async exportData() {
        let number = 50000;
        if (this.isShowSize) {
            if (this.size) {
                if (!(this.size > 0)) {
                    this.$Message.error({
                        content: i18n.t("formText.numberError") + "",
                    });
                    return;
                }
                number = Number(this.size);
            }
            if (number <= 0) {
                this.$Message.warning({
                    content: i18n.t("formText.exportPl") + "",
                });
                return;
            }
        }
        if (!this.loading) {
            const command = this.command;
            const json = {};
            if (this.isShowSize) {
                json[this.numberName] = number;
            }
            const data = Object.assign(this.data, json);
            for (let i in data) {
                if (data[i] == undefined) {
                    data[i] = "";
                }
            }
            if (data.endTime) {
                const thisTime = piThThisTimes("yyyy-MM-dd HH:MM:SS");
                const thisTimeArr = thisTime.split(" ");
                const endTimeArr = data.endTime.split(" ");
                if (thisTimeArr[0] === endTimeArr[0] &&
                    endTimeArr[1] &&
                    endTimeArr[1] === "23:59:59") {
                    // 如果结束时间为当前一天
                    data.endTime = thisTime;
                }
            }
            const loginData = this.sys.userInfo;
            data.merchantPkId = loginData.merchantPkId;
            data.oprPkId = loginData.oprPkId;
            // data.Suffix = command;
            this.command = command;
            this.loading = true;
            const headers = postHeaders({ filename: "utf-8" });
            let url = this.$config.ajaxHost + this.url;
            if (this.method === "postStr" || this.method === "get") {
                url = url + "?" + piOhParseParam(data);
            }
            axios({
                method: this.method === "get" ? "get" : "post",
                url: url,
                data: this.method === "postStr" ? {} : data,
                responseType: "arraybuffer",
                headers: headers,
                timeout: 5 * 60 * 1000,
                onDownloadProgress: (progress) => {
                    progress.srcElement.getResponseHeader("content-length");
                    // console.log(progress);
                    if (progress.total > 0) {
                        const text = Math.round((progress.loaded / progress.total) * 100);
                        if (this.progress == "" && text != 100) {
                            // 有的一上来就一百就算了，不显示 了
                            this.progress = text + "%";
                        }
                    }
                },
            })
                .then(async (result) => {
                this.loading = false;
                this.progress = "";
                this.ab2str(result.data, (str) => {
                    if (this.isJSON(str)) {
                        const jsonData = JSON.parse(str);
                        this.$Message.error(jsonData.msg);
                    }
                    else {
                        this.loadBlob(result.data);
                    }
                });
            })
                .catch((error) => {
                this.loading = false;
                this.progress = "";
                console.log(error);
                this.$Modal.error({
                    title: i18n.t("tips") + "",
                    content: i18n.t("formText.exportError") + "",
                });
                // this.$Message.error('')
            });
        }
    }
    ab2str(u, f) {
        const b = new Blob([u]);
        const r = new FileReader();
        const loadBlob = this.loadBlob;
        r.readAsText(b, "utf-8");
        r.onload = function () {
            if (f) {
                f.call(null, r.result); // eslint-disable-line
            }
        };
        r.onerror = function () {
            loadBlob(u);
        };
    }
    isJSON(str) {
        if (typeof str === "string") {
            try {
                const obj = JSON.parse(str);
                if (typeof obj === "object" && obj) {
                    return true;
                }
                else {
                    return false;
                }
            }
            catch (e) {
                return false;
            }
        }
        else {
            return false;
        }
    }
    loadBlob(data) {
        const blob = new Blob([data], {
            type: "application/octet-stream;charset=utf-8",
        });
        const win = window;
        const doc = document;
        const downloadElement = doc.createElement("a");
        const href = win.URL.createObjectURL(blob); // 创建下载的链接
        downloadElement.href = href;
        const time = this.fileName !== ""
            ? this.fileName + "-" + piThThisTimes("yyyy-MM-dd HH:MM:SS")
            : piThThisTimes("yyyy-MM-dd HH:MM:SS");
        downloadElement.download = time + this.command; // 下载后文件名
        doc.body.appendChild(downloadElement);
        downloadElement.click(); // 点击下载
        doc.body.removeChild(downloadElement); // 下载完成移除元素
        win.URL.revokeObjectURL(href); // 释放blob对象
        this.$emit("success");
    }
};
__decorate([
    State("sys")
], PiExport.prototype, "sys", void 0);
__decorate([
    Prop({
        default: () => {
            return {};
        },
    })
], PiExport.prototype, "data", void 0);
__decorate([
    Prop({ default: "" })
], PiExport.prototype, "fileName", void 0);
__decorate([
    Prop({ default: "post" })
], PiExport.prototype, "method", void 0);
__decorate([
    Prop({ default: ".xls" })
], PiExport.prototype, "command", void 0);
__decorate([
    Prop({ default: "" })
], PiExport.prototype, "url", void 0);
__decorate([
    Prop({ default: "size" })
], PiExport.prototype, "numberName", void 0);
__decorate([
    Prop({ default: true })
], PiExport.prototype, "isShowSize", void 0);
__decorate([
    Prop({ default: i18n.t("formText.export") })
], PiExport.prototype, "btnName", void 0);
__decorate([
    Prop({ default: "primary" })
], PiExport.prototype, "btnType", void 0);
__decorate([
    Prop({ default: "" })
], PiExport.prototype, "selectName", void 0);
__decorate([
    Prop({ default: false })
], PiExport.prototype, "disabled", void 0);
__decorate([
    Prop({ default: false })
], PiExport.prototype, "inline", void 0);
PiExport = __decorate([
    Component
], PiExport);
export default PiExport;
